"use client";
import React from "react";

export default function CtaMultipleButtons({data}) {
    const {
        title,
        subtitle,
        buttons = [],
        background = {},
        alignment = "center",
        padding = "xl"
    } = data || {};

    const bgStyle =
        background.type === "gradient"
            ? {backgroundImage: background.value}
            : background.type === "color"
                ? {backgroundColor: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

    const paddingMap = {
        sm: "py-8 px-4",
        md: "py-12 px-6",
        lg: "py-16 px-6",
        xl: "py-20 px-8"
    };

    const alignMap = {
        center: "text-center justify-center",
        left: "text-left justify-start",
        right: "text-right justify-end"
    };

    return (
        <section className={`${paddingMap[padding]} ${alignMap[alignment]?.split(" ")[0]}`} style={bgStyle}>
            <div className="max-w-4xl mx-auto">
                {title && <h2 className="text-3xl font-bold mb-2">{title}</h2>}
                {subtitle && <p className="text-lg text-gray-600 mb-5">{subtitle}</p>}

                <div className={`flex flex-wrap gap-4 ${alignMap[alignment] || "justify-center"}`}>
                    {buttons.map((btn, i) => (
                        <a
                            key={i}
                            href={btn.href}
                            className={`px-5 py-2 rounded-md font-medium text-sm transition ${
                                btn.style === "secondary"
                                    ? "bg-white text-blue-600 border border-blue-600 hover:bg-blue-50"
                                    : "bg-blue-600 text-white hover:bg-blue-700"
                            }`}
                        >
                            {btn.text}
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}